// Mirror of the C++ common::routing::topic_matches semantics.
//   *   matches exactly one segment
//   **  matches one or more segments at any depth
//
// Used client-side to dedup subscription patterns and decide whether
// an inbound event should land on a given screen's handler.

export function splitSegments(dotted: string): string[] {
  return dotted.split('.');
}

export function topicMatches(pattern: string, topic: string): boolean {
  return matchSegments(splitSegments(pattern), splitSegments(topic));
}

function matchSegments(pat: string[], top: string[]): boolean {
  return matchFrom(pat, 0, top, 0);
}

function matchFrom(pat: string[], pi: number, top: string[], ti: number): boolean {
  while (pi < pat.length && ti < top.length) {
    const p = pat[pi]!;
    if (p === '**') {
      if (pi + 1 === pat.length) {
        return ti < top.length;
      }
      for (let consume = 1; ti + consume <= top.length; consume += 1) {
        if (matchFrom(pat, pi + 1, top, ti + consume)) return true;
      }
      return false;
    }
    if (p === '*' || p === top[ti]) {
      pi += 1;
      ti += 1;
      continue;
    }
    return false;
  }
  if (pi < pat.length && pat[pi] === '**') {
    return ti < top.length;
  }
  return pi === pat.length && ti === top.length;
}
